import { clearWeekdayToRest } from './clearWeekdayToRest';
import { assignTemplateToWeekday } from './assignTemplateToWeekday';

/**
 * Remove the current weekday assignment, delete the plan when it is only used on
 * this day, then assign a new template (fresh plan).
 */
export async function replaceTemplateOnWeekday({
  post,
  eventTypeId,
  assigneeId,
  durationId,
  weekdayId,
  weekdayName = '',
  templateId,
  templateName,
  planToReplace,
  planDescription = '',
  weekdayDetails = null,
}) {
  const clearResult = await clearWeekdayToRest({
    post,
    eventTypeId,
    planToClear: planToReplace,
    weekdayName,
    weekdayDetails,
  });

  if (!clearResult.success) {
    return {
      success: false,
      message: clearResult.message || 'Failed to remove existing workout.',
    };
  }

  return assignTemplateToWeekday({
    post,
    eventTypeId,
    assigneeId,
    durationId,
    weekdayId,
    weekdayName,
    templateId,
    templateName,
    planDescription,
    weekdayDetails,
    forceNewPlan: true,
  });
}
